// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.error-modal {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.error-modal-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-modal-close:hover {
  color: #333;
}

.error-modal-title {
  color: #dc2626;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.error-modal-message {
  color: #374151;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.error-modal-button {
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;
}

.error-modal-button:hover {
  background-color: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/ErrorModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".error-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.error-modal {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  max-width: 400px;\n  width: 90%;\n  position: relative;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.error-modal-close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.error-modal-close:hover {\n  color: #333;\n}\n\n.error-modal-title {\n  color: #dc2626;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.error-modal-message {\n  color: #374151;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.error-modal-button {\n  width: 100%;\n  padding: 0.5rem 1rem;\n  background-color: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-weight: 500;\n}\n\n.error-modal-button:hover {\n  background-color: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
